import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ApiLocationService} from '@services/api-location/api-location.service';
import {MailSettings} from '@models/adminstration/organization/mail/mail-settings';
import {Observable} from 'rxjs';
import {MailTemplate} from '@models/adminstration/organization/mail/mail-template';
import {HTTPS_REQUEST_OPTIONS} from '@constants/https-request-options/https-request-options';

@Injectable({
  providedIn: 'root'
})
export class MailTemplateService {
  private readonly BASE_URL: string;
  ORGANIZATION_TEMPLATES_GET_URL_SUFFIX: string = '/api/web/admin/tenant/:id/mail/templates';
  ORGANIZATION_TEMPLATES_SAVE_URL_SUFFIX: string = '/api/web/admin/tenant/:id/mail/templates/save';
  ORGANIZATION_TEMPLATES_FALLBACK_URL_SUFFIX: string = '/api/web/admin/tenant/:id/mail/templates/getFallback/:type';

  constructor(private http: HttpClient,
              private apiLocation: ApiLocationService) {
    this.BASE_URL = this.apiLocation.getLocation();
  }

  public getTemplates(organizationId: number): Observable<any> {
    let url: string = this.BASE_URL + this.ORGANIZATION_TEMPLATES_GET_URL_SUFFIX;
    url = url.replace(':id', String(organizationId));
    console.debug(url);

    return this.http.get<MailSettings>(url, HTTPS_REQUEST_OPTIONS);
  }

  public saveTemplates(organizationId: number, settings: MailSettings): Observable<any> {
    let url: string = this.BASE_URL + this.ORGANIZATION_TEMPLATES_SAVE_URL_SUFFIX;
    url = url.replace(':id', String(organizationId));
    console.debug(url);

    return this.http.post<MailSettings>(url, settings, HTTPS_REQUEST_OPTIONS);
  }

  public getFallbackTemplate(organizationId: number, type: string): Observable<any> {
    let url: string = this.BASE_URL + this.ORGANIZATION_TEMPLATES_FALLBACK_URL_SUFFIX;
    url = url.replace(':id', String(organizationId));
    url = url.replace(':type', String(type));
    console.debug(url);

    return this.http.get<MailTemplate>(url, HTTPS_REQUEST_OPTIONS);
  }
}
